import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import SupportEmailModal from "../../organisms/SupportEmail/SupportEmailModal";
import HomeMenu from "../../molecules/HomeMenu/HomeMenu";
import styles from "./Home.css";
import { requestMaker } from "../../../helpers/requestMaker";
import { SimpleAuthContext } from "../../../helpers/SimpleAuthProvider";
import DecisionMaker from "../../../assets/DecisionMaker";

const Home = ({ setTitle }) => {
  const [dataFromFetch, setDataFromFetch] = useState({});
  var { user } = useContext(SimpleAuthContext);

  const [showAdmin, setShowAdmin] = useState(false);

  const [dataFetch, setDataFetch] = useState();
  useEffect(() => {
    const fetchData = async () => {
      const data = await requestMaker(
        user,
        "GET",
        "User/GetUserRole",
        localStorage.getItem("token")
      );
      if (data) {
        setShowAdmin(true);
      }
      setDataFromFetch(data);
    };
    fetchData();
  }, []);

  useEffect(() => {
    setTitle("");
  }, []);
  return (
    <>
      <SupportEmailModal />
      <HomeMenu />
      <div className="homeContainer">
        <ul>
          <h3 className={styles}>Välj process</h3>
          {/* VIP är avvecklad i Digital Forms. Raden är kvar, utgråad, och leder till infosidan (VipRetired). */}
          <Link to="/vip" className="retiredProcessLink" title="VIP har ersatts av Sweden Stars. Klicka för mer information.">
            <li className="retiredProcess">
              <span>VIP - Value In People</span>
              <span className="retiredProcessBadge">Avvecklad</span>
              <span className="retiredProcessInfo" aria-label="Information">
                <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
                  <circle cx="12" cy="8" r="1.4" fill="currentColor" />
                  <rect x="10.8" y="11" width="2.4" height="7" rx="1.2" fill="currentColor" />
                </svg>
              </span>
            </li>
          </Link>
          <Link to="/vehicle">
            <li>Bilbeställning</li>
          </Link>
          <Link to="/leaveApplication">
            <li>Ledighetsansökan</li>
          </Link>
          <Link to="/recruiting">
            <li>Finders Fee - Rekryteringsbonus</li>
          </Link>
          <Link to="/overtime">
            <li>Ansökan - Extra övertid</li>
          </Link>
          <Link to="/suggestionBox">
            <li>Förslagslåda</li>
          </Link>
          <Link to="/bonus">
            <li>Ansökan - Certifieringsbonus</li>
          </Link>

          {showAdmin ? (
            <Link to="/admin">
              <li>Admin portal</li>
            </Link>
          ) : null}

          {/* <Link to="/admin">
            <li>
              Admin portal
            </li>
          </Link> */}
        </ul>
      </div>
    </>
  );
};

export default Home;
